"use client";
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const useWarning_1 = require("../../hooks/useWarning");
const Target_1 = require("../Target");
const Link = (props) => {
    const { warnDeprecation } = (0, useWarning_1.useWarning)();
    const { disabled = false, icon, iconPosition = "start", children, sx, variant = "default" } = props, restProps = __rest(props, ["disabled", "icon", "iconPosition", "children", "sx", "variant"]);
    if (iconPosition === "left" || iconPosition === "right") {
        warnDeprecation("The 'left' and 'right' `iconPosition` is deprecated and will be removed in future versions. Please use 'start' and 'end' instead.");
    }
    const iconStart = react_1.default.useMemo(() => iconPosition === "left" || iconPosition === "start", [iconPosition]);
    const iconEnd = react_1.default.useMemo(() => iconPosition === "right" || iconPosition === "end", [iconPosition]);
    const linkStyles = Object.assign(Object.assign({ alignItems: "center", color: disabled ? "disabled01" : "link01", display: icon ? "inline-flex" : undefined, fontSize: "inherit", fontWeight: "inherit", gap: 2, textDecoration: "underline", textDecorationColor: variant === "default" ? "transparent" : "currentColor", transition: "colorMedium" }, (disabled
        ? {}
        : {
            "&:focus-visible": {
                borderColor: "link01",
                borderRadius: "medium",
                borderStyle: "solid",
                color: "cta02Text",
                paddingX: 1,
                paddingY: 0
            },
            "&:hover": {
                color: "cta02TextHover",
                textDecorationColor: "cta02TextHover",
                "> *": {
                    // for having the icon color change during hover
                    color: "cta02TextHover"
                }
            },
            "&:active": {
                color: "cta02TextHover",
                textDecorationColor: "cta02TextHover"
            }
        })), sx);
    return (react_1.default.createElement(Target_1.Target, Object.assign({}, restProps, { sx: Object.assign({}, linkStyles), disabled: disabled }),
        icon && iconStart && (react_1.default.createElement(foundations_1.Icon, { icon: icon, 
            // "em"s are not valid "sx" theme type, though it is required here
            // to resize the icon with the font size
            // @ts-ignore
            sx: { size: "1em" } })),
        children,
        icon && iconEnd && (react_1.default.createElement(foundations_1.Icon, { icon: icon, 
            // "em"s are not valid "sx" theme type, though it is required here
            // to resize the icon with the font size
            // @ts-ignore
            sx: { size: "1em" } }))));
};
exports.Link = Link;
//# sourceMappingURL=Link.js.map